import { START_POWER_TREE_SIMULATION } from '../actionType';

export const startPowerTreeSimulation = (id, runType) => ({
  type: START_POWER_TREE_SIMULATION,
  id,
  runType
})